import * as THREE from 'three';
import * as marietta from '../../marietta';
/* tslint:disable:no-any */

export default class MouseControls {
  enabled: boolean;

  orientation: { x: number; y: number };

  oldPos: { x: number; y: number };

  _el: HTMLElement;

  object: THREE.Object3D;

  xVector: THREE.Vector3;

  yVector: THREE.Vector3;

  mouseQuat = {
    x: new THREE.Quaternion(),
    y: new THREE.Quaternion(),
  };

  speed: number;

  /**
   * dispose
   */
  public dispose: () => void;

  /**
   * update
   */
  public update: () => void;

  constructor(object: THREE.Object3D, container: HTMLElement) {
    this._el = container;
    this.object = object;
    this.xVector = new THREE.Vector3(1, 0, 0);
    this.yVector = new THREE.Vector3(0, 1, 0);
    this.enabled = true;
    this.speed = 0.005;
    this.orientation = {
      x: 0,
      y: 0,
    };
    this.oldPos = {
      x: 0,
      y: 0,
    };

    function move(x: number, y: number): void {
      const PI_2 = Math.PI / 2;

      const movementX = x - this.oldPos.x;
      const movementY = y - this.oldPos.y;
      this.oldPos.x = x;
      this.oldPos.y = y;

      this.orientation.y += movementX * this.speed;
      this.orientation.x += movementY * this.speed;

      this.orientation.x = Math.max(-PI_2, Math.min(PI_2, this.orientation.x));
    }

    function onTouchMove(event: any): void {
      if (this.enabled === false) return;
      move(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
    }

    function onTouchStart(event: any): void {
      if (this.enabled === false) return;
      this.oldPos.x = event.changedTouches[0].pageX;
      this.oldPos.y = event.changedTouches[0].pageY;

      this._el.addEventListener('touchmove', onTouchMove, false);
    }

    function onTouchEnd(): void {
      if (this.enabled === false) return;
      this._el.removeEventListener('touchmove', onTouchMove, false);
    }

    function onMouseMove(event: any): void {
      if (this.enabled === false) return;
      move(event.clientX, event.clientY);
    }

    function onMouseDown(event: any): void {
      if (this.enabled === false) return;
      this.oldPos.x = event.clientX;
      this.oldPos.y = event.clientY;

      document.addEventListener('mousemove', onMouseMove, false);
    }

    function onMouseUp(): void {
      if (this.enabled === false) return;
      document.removeEventListener('mousemove', onMouseMove, false);
    }

    if (marietta.view3d.base.Config.me.isTouchMode(this._el)) {
      // タッチ対応（スマホ・タブレット）
      this._el.addEventListener('touchstart', onTouchStart);
      this._el.addEventListener('touchend', onTouchEnd);
    }
    document.addEventListener('mousedown', onMouseDown, false);
    document.addEventListener('mouseup', onMouseUp, false);

    this.update = (): void => {
      if (this.enabled === false) return;
      this.mouseQuat.x.setFromAxisAngle(this.xVector, this.orientation.x);
      this.mouseQuat.y.setFromAxisAngle(this.yVector, this.orientation.y);
      this.object.quaternion.copy(this.mouseQuat.y).multiply(this.mouseQuat.x);
      // return;
    };

    this.dispose = (): void => {
      document.removeEventListener('mousedown', onMouseDown, false);
      document.removeEventListener('mouseup', onMouseUp, false);
    };
  }
}
